/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreatePriceDto } from '../models/work-create-price-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkPrice } from '../models/work-price';
import { WorkSuccessDto } from '../models/work-success-dto';

@Injectable({ providedIn: 'root' })
export class WorkPricesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pricesV2ControllerFindAllPaginated()` */
  static readonly PricesV2ControllerFindAllPaginatedPath = '/v2/prices';

  /**
   * Required permissions: prices:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pricesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  pricesV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by isFactorBased query param.
     *           <p>
     *              <b>Format: </b> filter.isFactorBased={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.isFactorBased=$not:$like:John Doe&filter.isFactorBased=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.isFactorBased'?: Array<string>;

    /**
     * Filter by validFrom query param.
     *           <p>
     *              <b>Format: </b> filter.validFrom={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.validFrom=$not:$like:John Doe&filter.validFrom=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.validFrom'?: Array<string>;

    /**
     * Filter by validTo query param.
     *           <p>
     *              <b>Format: </b> filter.validTo={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.validTo=$not:$like:John Doe&filter.validTo=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.validTo'?: Array<string>;

    /**
     * Filter by itemId query param.
     *           <p>
     *              <b>Format: </b> filter.itemId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.itemId=$not:$like:John Doe&filter.itemId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.itemId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>priceEur</li>
     * <li>priceChf</li>
     * <li>purchaseChf</li>
     * <li>saleChf</li>
     * <li>validFrom</li>
     * <li>validTo</li>
     * <li>active</li>
     * <li>materialSalePrice</li>
     * <li>workSalePrice</li>
     * <li>priceFactor</li>
     * <li>isFactorBased</li></ul>
     */
      sortBy?: Array<'priceEur:ASC' | 'priceEur:DESC' | 'priceChf:ASC' | 'priceChf:DESC' | 'purchaseChf:ASC' | 'purchaseChf:DESC' | 'saleChf:ASC' | 'saleChf:DESC' | 'validFrom:ASC' | 'validFrom:DESC' | 'validTo:ASC' | 'validTo:DESC' | 'active:ASC' | 'active:DESC' | 'materialSalePrice:ASC' | 'materialSalePrice:DESC' | 'workSalePrice:ASC' | 'workSalePrice:DESC' | 'priceFactor:ASC' | 'priceFactor:DESC' | 'isFactorBased:ASC' | 'isFactorBased:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> validFrom,validTo,active,itemId,isFactorBased
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>validFrom</li>
     * <li>validTo</li>
     * <li>active</li>
     * <li>itemId</li>
     * <li>isFactorBased</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkPrice>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'isFactorBased'?: (string | Array<string>);
'validFrom'?: (string | Array<string>);
'validTo'?: (string | Array<string>);
'itemId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPricesV2Service.PricesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.isFactorBased', params['filter.isFactorBased'], {});
      rb.query('filter.validFrom', params['filter.validFrom'], {});
      rb.query('filter.validTo', params['filter.validTo'], {});
      rb.query('filter.itemId', params['filter.itemId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkPrice>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        'isFactorBased'?: (string | Array<string>);
        'validFrom'?: (string | Array<string>);
        'validTo'?: (string | Array<string>);
        'itemId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: prices:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pricesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pricesV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by isFactorBased query param.
     *           <p>
     *              <b>Format: </b> filter.isFactorBased={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.isFactorBased=$not:$like:John Doe&filter.isFactorBased=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.isFactorBased'?: Array<string>;

    /**
     * Filter by validFrom query param.
     *           <p>
     *              <b>Format: </b> filter.validFrom={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.validFrom=$not:$like:John Doe&filter.validFrom=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.validFrom'?: Array<string>;

    /**
     * Filter by validTo query param.
     *           <p>
     *              <b>Format: </b> filter.validTo={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.validTo=$not:$like:John Doe&filter.validTo=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.validTo'?: Array<string>;

    /**
     * Filter by itemId query param.
     *           <p>
     *              <b>Format: </b> filter.itemId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.itemId=$not:$like:John Doe&filter.itemId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.itemId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>priceEur</li>
     * <li>priceChf</li>
     * <li>purchaseChf</li>
     * <li>saleChf</li>
     * <li>validFrom</li>
     * <li>validTo</li>
     * <li>active</li>
     * <li>materialSalePrice</li>
     * <li>workSalePrice</li>
     * <li>priceFactor</li>
     * <li>isFactorBased</li></ul>
     */
      sortBy?: Array<'priceEur:ASC' | 'priceEur:DESC' | 'priceChf:ASC' | 'priceChf:DESC' | 'purchaseChf:ASC' | 'purchaseChf:DESC' | 'saleChf:ASC' | 'saleChf:DESC' | 'validFrom:ASC' | 'validFrom:DESC' | 'validTo:ASC' | 'validTo:DESC' | 'active:ASC' | 'active:DESC' | 'materialSalePrice:ASC' | 'materialSalePrice:DESC' | 'workSalePrice:ASC' | 'workSalePrice:DESC' | 'priceFactor:ASC' | 'priceFactor:DESC' | 'isFactorBased:ASC' | 'isFactorBased:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> validFrom,validTo,active,itemId,isFactorBased
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>validFrom</li>
     * <li>validTo</li>
     * <li>active</li>
     * <li>itemId</li>
     * <li>isFactorBased</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkPrice>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'isFactorBased'?: (string | Array<string>);
'validFrom'?: (string | Array<string>);
'validTo'?: (string | Array<string>);
'itemId'?: (string | Array<string>);
};
};
}> {
    return this.pricesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkPrice>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'isFactorBased'?: (string | Array<string>);
'validFrom'?: (string | Array<string>);
'validTo'?: (string | Array<string>);
'itemId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkPrice>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'isFactorBased'?: (string | Array<string>);
'validFrom'?: (string | Array<string>);
'validTo'?: (string | Array<string>);
'itemId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `pricesV2ControllerCreate()` */
  static readonly PricesV2ControllerCreatePath = '/v2/prices';

  /**
   * Required permissions: prices:create
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pricesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pricesV2ControllerCreate$Response(
    params: {
      body: WorkCreatePriceDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPrice>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPricesV2Service.PricesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPrice>;
      })
    );
  }

  /**
   * Required permissions: prices:create
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pricesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pricesV2ControllerCreate(
    params: {
      body: WorkCreatePriceDto
    },
    context?: HttpContext
  ): Observable<WorkPrice> {
    return this.pricesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPrice>): WorkPrice => r.body)
    );
  }

  /** Path part for operation `pricesV2ControllerGetCurrentPriceForItemId()` */
  static readonly PricesV2ControllerGetCurrentPriceForItemIdPath = '/v2/prices/byItemId/{itemId}';

  /**
   * Required permissions: prices:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pricesV2ControllerGetCurrentPriceForItemId()` instead.
   *
   * This method doesn't expect any request body.
   */
  pricesV2ControllerGetCurrentPriceForItemId$Response(
    params: {

    /**
     * item ID
     */
      itemId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPrice>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPricesV2Service.PricesV2ControllerGetCurrentPriceForItemIdPath, 'get');
    if (params) {
      rb.path('itemId', params.itemId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPrice>;
      })
    );
  }

  /**
   * Required permissions: prices:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pricesV2ControllerGetCurrentPriceForItemId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pricesV2ControllerGetCurrentPriceForItemId(
    params: {

    /**
     * item ID
     */
      itemId: number;
    },
    context?: HttpContext
  ): Observable<WorkPrice> {
    return this.pricesV2ControllerGetCurrentPriceForItemId$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPrice>): WorkPrice => r.body)
    );
  }

  /** Path part for operation `pricesV2ControllerUpdate()` */
  static readonly PricesV2ControllerUpdatePath = '/v2/prices/{id}';

  /**
   * Required permissions: prices:create
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pricesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pricesV2ControllerUpdate$Response(
    params: {

    /**
     * Price ID
     */
      id: number;
      body: WorkCreatePriceDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPricesV2Service.PricesV2ControllerUpdatePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: prices:create
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pricesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pricesV2ControllerUpdate(
    params: {

    /**
     * Price ID
     */
      id: number;
      body: WorkCreatePriceDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.pricesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pricesV2ControllerDeletePrice()` */
  static readonly PricesV2ControllerDeletePricePath = '/v2/prices/{id}';

  /**
   * Required permissions: prices:delete
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pricesV2ControllerDeletePrice()` instead.
   *
   * This method doesn't expect any request body.
   */
  pricesV2ControllerDeletePrice$Response(
    params: {

    /**
     * Price ID
     */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPricesV2Service.PricesV2ControllerDeletePricePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: prices:delete
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pricesV2ControllerDeletePrice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pricesV2ControllerDeletePrice(
    params: {

    /**
     * Price ID
     */
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.pricesV2ControllerDeletePrice$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
